import * as types from '../constants/actionTypes';

const initialState = {
    loaded: false,
    userProfiles: [],
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        // fetchUser
        case types.LOAD:
            return {
                ...state,
                loading: true,
            };
        case types.LOAD_SUCCESS:
            return {
                ...state,
                loading: false,
                loaded: true,
                user: action.result,
            };
        case types.LOAD_FAIL:
            return {
                ...state,
                loading: false,
                loaded: false,
                error: action.error,
            };

        // fetch user profiles
        case types.FETCH_USER_PROFILES:
            return { ...state };
        case types.FETCH_USER_PROFILES_SUCCESS:
            return {
                ...state,
                userProfiles:
                    !action.result || !Object.keys(action.result).length
                        ? []
                        : action.result,
            };
        case types.FETCH_USER_PROFILES_FAIL:
            return { ...state, error: action.error };
        default:
            return state;
    }
}
